/**
 * Notificaciones push (33, Robert 16/10/2026): lo puro de activarlas en el móvil. Planteamiento del
 * ERP de Oxyon (sin copiar su código): en iPhone solo funcionan con la app instalada en la pantalla
 * de inicio, y el permiso se pide al tocar el botón.
 */

export type EstadoPush = "si" | "instalar_primero" | "no";

export type Navegador = {
  serviceWorker: boolean;
  pushManager: boolean;
  notification: boolean;
  userAgent: string;
  maxTouchPoints: number;
  /** display-mode: standalone o navigator.standalone (app instalada). */
  instalada: boolean;
};

/** iPhone o iPad (los iPad modernos dicen ser un Mac, pero con pantalla táctil). */
export const esIphone = (userAgent: string, maxTouchPoints: number) =>
  /iPhone|iPad|iPod/.test(userAgent) ||
  (/Macintosh/.test(userAgent) && maxTouchPoints > 1);

export const estadoPush = (n: Navegador): EstadoPush => {
  if (esIphone(n.userAgent, n.maxTouchPoints) && !n.instalada) {
    return "instalar_primero";
  }
  return n.serviceWorker && n.pushManager && n.notification ? "si" : "no";
};

/** Un nombre para reconocer el aparato en la lista («iPhone», «Android»…). */
export const nombreDispositivo = (userAgent: string, maxTouchPoints = 0) => {
  if (
    /iPad/.test(userAgent) ||
    (/Macintosh/.test(userAgent) && maxTouchPoints > 1)
  )
    return "iPad";
  if (/iPhone/.test(userAgent)) return "iPhone";
  if (/Android/.test(userAgent)) return "Android";
  if (/Windows/.test(userAgent)) return "Ordenador Windows";
  if (/Macintosh/.test(userAgent)) return "Mac";
  return "Otro aparato";
};

/** La clave pública VAPID (base64url) como la pide pushManager.subscribe. */
export const claveAplicacion = (base64url: string): Uint8Array => {
  const relleno = "=".repeat((4 - (base64url.length % 4)) % 4);
  const base64 = (base64url + relleno).replace(/-/g, "+").replace(/_/g, "/");
  const binario = atob(base64);
  return Uint8Array.from(binario, (c) => c.charCodeAt(0));
};
